import { Model } from 'pinia-orm';
import Job from './Job';
import ComponentJob from './ComponentJob';
import Image from './Image';
import ComponentImage from './ComponentImage';
import Location from './Location';
import ComponentLocation from './ComponentLocation';
import Value from './Value';
import ComponentValue from './ComponentValue';
import Member from './Member';
import ComponentQuote from './ComponentQuote';
import Quote from './Quote';
import ComponentMember from './ComponentMember';
import ComponentTwitter from './ComponentTwitter';
import ComponentFacebook from './ComponentFacebook';
import Fact from './Fact';
import ComponentFact from './ComponentFact';
import Perk from './Perk';
import ComponentPerk from './ComponentPerk';
import Award from './Award';
import ComponentAward from './ComponentAward';


export default class Component extends Model {

    static get entity () {
        return 'components';
    }

    static fields () {
        return {
            id: this.uid(),
            company_id: this.attr(null),
            type: this.attr(null),
            title: this.attr({}),
            description: this.attr({}),
            order: this.attr(0),
            rerenderCount: this.attr(0),
            settings: this.attr({}),
            identifier: this.attr(null),
            style: this.attr(null),
            published: this.attr({}),
            created_at: this.attr(null),
            updated_at: this.attr(null),

            //Fields for some components
            url: this.attr(null),
            translated_url: this.attr({}),

            //Text fields
            heading: this.attr({}),
            content: this.attr({}),

            //Video fields
            source: this.attr(null),

            //Team fields
            is_mandatory: this.attr(null),
            is_job: this.attr(null),
            members_count: this.attr(0),

            //Gallery fields
            caption: this.attr({}),

            //Job fields
            filters: this.attr([]),
            pagination: this.attr(null),

            //Relationships
            jobs: this.belongsToMany(Job, ComponentJob, 'component_id', 'job_id'),
            images: this.belongsToMany(Image, ComponentImage, 'component_id', 'image_id'),
            locations: this.belongsToMany(Location, ComponentLocation, 'component_id', 'location_id'),
            values: this.belongsToMany(Value, ComponentValue, 'component_id', 'value_id'),
            members: this.belongsToMany(Member, ComponentMember, 'component_id', 'member_id'),
            quotes: this.belongsToMany(Quote, ComponentQuote, 'component_id', 'quote_id'),
            facts: this.belongsToMany(Fact, ComponentFact, 'component_id', 'fact_id'),
            perks: this.belongsToMany(Perk, ComponentPerk, 'component_id', 'perk_id'),
            awards: this.belongsToMany(Award, ComponentAward, 'component_id', 'award_id'),
        }
    }

    static formFields (type) {
        switch (type) {
            case 'video':
                return [
                    { name: 'title', value: {}, translatable: true},
                    { name: 'description', value: {}, translatable: true},
                    { name: 'url', value: ''},
                    { name: 'translated_url', value: {}, translatable: true},
                    { name: 'published', value: true, translatable: true, accessor: Boolean},
                    { name: 'identifier', value: ''},
                ];
                break;
            case 'text':
                return [
                    { name: 'content', value: {}, translatable: true},
                    { name: 'heading', value: {}, translatable: true},
                    { name: 'published', value: true, translatable: true, accessor: Boolean},
                    { name: 'identifier', value: ''},
                ];
                break;
            case 'jobs':
                return [
                    { name: 'title', value: {}, translatable: true},
                    { name: 'description', value: {}, translatable: true},
                    { name: 'published', value: true, translatable: true, accessor: Boolean},
                    { name: 'filters', value: {}},
                    { name: 'pagination', value: null},
                    { name: 'identifier', value: ''},
                ];
                break;
            case 'twitter':
                return ComponentTwitter.formFields();
                break;

            case 'facebook':
                return ComponentFacebook.formFields();
                break;

            case 'quotes':
                return [
                    {name: 'items', value: []},
                    {name: 'published', value: true, translatable: true, accessor: Boolean},
                    {name: 'identifier', value: ''},
                ];
                break;
            case 'image':
            case 'gallery':
                return [
                    {name: 'items', value: []},
                    {name: 'title', value: {}, translatable: true},
                    {name: 'description', value: {}, translatable: true},
                    {name: 'published', value: true, translatable: true, accessor: Boolean},
                    {name: 'caption', value: {}, translatable: true},
                    {name: 'identifier', value: ''},
                ];
                break;
            case 'awards':
            case 'values':
            case 'team':
            case 'facts':
            case 'perks':
            case 'locations':
                return [
                    {name: 'items', value: []},
                    {name: 'title', value: {}, translatable: true},
                    {name: 'description', value: {}, translatable: true},
                    {name: 'published', value: true, translatable: true, accessor: Boolean},
                    {name: 'identifier', value: ''},
                ]
                break;
            default:
                return [
                    {name: 'content', value: {}, translatable: true},
                    {name: 'published', value: true, translatable: true, accessor: Boolean},
                ];
                break;
        }
    }

    static formatBeforeSave (formData, component) {
        let data = {
            type: 'components',
            component_type: component.type,
            attributes: {
                title: formData.title,
                description: formData.description,
                order: component.position,
                published: formData.published,
                identifier: formData.identifier,
            }
        };

        switch (component.type) {
            case 'image':
                data.component_type = 'gallery';
                data.attributes.settings = {single: true};
                data.attributes.caption = formData.caption;
                return ComponentImage.formatBeforeSave(data, formData);
                break;
            case 'gallery':
                data.attributes.settings = {single: false};
                return ComponentImage.formatBeforeSave(data, formData);
                break;
            case 'quotes':
                return ComponentQuote.formatBeforeSave(data, formData);
                break;
            case 'team':
                return ComponentMember.formatBeforeSave(data, formData);
                break;
            case 'facts':
                return ComponentFact.formatBeforeSave(data, formData);
                break;
            case 'perks':
                return ComponentPerk.formatBeforeSave(data, formData);
                break;
            case 'values':
                return ComponentValue.formatBeforeSave(data, formData);
                break;
            case 'awards':
                return ComponentAward.formatBeforeSave(data, formData);
                break;
            case 'locations':
                return ComponentLocation.formatBeforeSave(data, formData);
                break;
            default:
                data.attributes = {...data.attributes, ...formData};
                return data;
                break;
        }
    }

    get componentTypes () {
        return [
            'awards',
            'facebook',
            'facts',
            'gallery',
            'instagram',
            'jobs',
            'linkedin',
            'locations',
            'perks',
            'quotes',
            'team',
            'text',
            'twitter',
            'values',
            'video'
        ];
    }

    get typeToItem () {
        return {
            awards: 'awards',
            facebook: null,
            facts: 'facts',
            gallery: 'images',
            instagram: null,
            jobs: 'jobs',
            linkedin: null,
            locations: 'locations',
            perks: 'perks',
            quotes: 'quotes',
            team: 'members',
            text: null,
            twitter: null,
            values: 'values',
            video: null
        };
    }

    get pools () {
        return [
            'awards',
            'facts',
            'gallery',
            'jobs',
            'locations',
            'perks',
            'quotes',
            'team',
            'values'
        ];
    }

    get itemName () {
        if (!this.isPool) {
            return null;
        }

        return this.typeToItem[this.type];
    }

    get items () {
        if (!this.isPool) {
            return null;
        }

        let items = [];

        for (let item of this[this.itemName]) {
            if (item.pivot !== null) {
                items.push({id: item.id, order: item.pivot.order});
            }
        }

        return items;
    }

    get isPool () {
        return this.componentTypes.indexOf(this.type) > -1;
    }

    static withSortedItems(input) {
        if (!input) return null;
        if (!Array.isArray(input)) {
            console.error("Invalid call to Component.withSortedItems.  Array expected.");
            return input;
        }

        const sort = (pool) => {
            if (!pool) return [];
            return pool.sort((a, b) => (a.pivot?.order ?? 0) - (b.pivot?.order ?? 0) );
        };


        const sortItems = (component) => {
            sort(component.awards),
                sort(component.facts),
                sort(component.images),
                sort(component.locations),
                sort(component.members),
                sort(component.perks),
                sort(component.quotes),
                sort(component.values)
        };
        input.forEach((x) => sortItems(x));
        return input;
    }
}
